import SectionHeading from "@/components/base/SectionHeading";
import WorkCard from "@/components/base/WorkCard";
import { getHotWorks } from "@/lib/workUtils";

export default function HotWorks() {
  const list = getHotWorks(6);
  return (
    <section className="mx-auto w-full px-4 pb-12 md:px-8 md:pb-16">
      <SectionHeading
        title="热门影视推荐"
        subtitle="按播放热度与评分综合排行，影迷都在看"
        moreTo="/category/movie"
        moreLabel="浏览全部"
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
        {list.map((work, index) => (
          <div key={work.id} className="relative">
            <span className="pointer-events-none absolute -top-2 left-0 z-10 font-heading text-4xl font-black text-background-300">
              {String(index + 1).padStart(2, "0")}
            </span>
            <WorkCard work={work} />
          </div>
        ))}
      </div>
    </section>
  );
}